import React, { useCallback, useEffect, useMemo } from "react";

import { getAnObjectSections } from "../../redux/actions/anObjectSectionActions";
import { getAnObjectSubSections } from "../../redux/actions/anObjectSubSectionActions";
import { getDepartments } from "../../redux/actions/departmentActions";
import { getDiseases } from "../../redux/actions/diseaseActions";
import { getDivisions } from "../../redux/actions/divisionActions";
import { getEmployees } from "../../redux/actions/employeeActions";
import { getFilials } from "../../redux/actions/filialActions";
import { getFilialDivisions } from "../../redux/actions/filialDivisionActions";
import { getGeoObjects } from "../../redux/actions/geoObjectActions";
import { getGovernmentStandards } from "../../redux/actions/governmentStandardActions";
import { getInfectionKinds } from "../../redux/actions/infectionKindActions";
import { getLegalPersons } from "../../redux/actions/legalPersonActions";
import { getMedicalOrders } from "../../redux/actions/medicalOrderActions";
import { getPurposeOfSelections } from "../../redux/actions/purposeOfSelectionActions";
import { getReferralAdditionalInfos } from "../../redux/actions/referralAdditionalInfoActions";
import { getReferralOrderTypes } from "../../redux/actions/referralOrderTypeActions";
import { getSamplePreservationMethods } from "../../redux/actions/samplePreservationMethodActions";
import { getSamplingPurposes } from "../../redux/actions/samplingPurposeActions";
import { getStorageConditions } from "../../redux/actions/storageConditionActions";
import { getTechnicalRegulationsOfCustomsUnions } from "../../redux/actions/technicalRegulationsOfCustomsUnionActions";
import { getTransportationConditions } from "../../redux/actions/transportationConditionActions";
import DomainSelect from "./DomainSelect";
import DomainSelect2 from "./DomainSelect2";
import { committeeObjectCRUD, factorCRUD, filialDivisionCRUD } from "../../http";
import { getPositions } from "../../redux/actions/positionActions";
import { getRoles } from "../../redux/actions/roleActions";
import { mapRole } from "../../functions/viewDataMap";
import {getServices} from "../../redux/actions/serviceActions";
import {getProtocolForms} from "../../redux/actions/protocolFormActions";
import {getResultForms} from "../../redux/actions/resultFormActions";
import {getBrigadeTypes} from "../../redux/actions/brigadeTypeActions";
import { getGenders } from "../../redux/actions/genderActions";
import {getProbeTypes} from "../../redux/actions/probeTypeActions";
import {getActForms} from "../../redux/actions";

import { getContracts } from "../../redux/actions";
import { CONTRACT_TYPE_ID_GOVERNMENT_REQUESTS } from "../../redux/constants/contractTypeConstants";
import { mapOrganizationValues } from "../../functions/viewDataMap";
import {
  normalizePurposeName,
  PURPOSE_OF_SELECTION_EXCLUDE,
} from "../../functions/objectSectionFilters";
import {getUnitOfMeasures} from "../../redux/actions/unitOfMeasureActions";
import {getServiceGroups} from "../../redux/actions/serviceGroupActions";
import {getServiceKinds} from "../../redux/actions/serviceKindActions";
import {getServiceSubGroups} from "../../redux/actions/serviceSubGroupActions";
import {getServiceCategories} from "../../redux/actions/serviceCategoryActions";
import {getResultsType} from "../../redux/actions/resultTypeActions";
import { getResearchObjects } from "../../redux/actions/researchObjectActions";
import TrainingProgramSelect from "./TrainingProgramSelect";
import TrainingTargetGroupSelect from "./TrainingTargetGroupSelect";

export const PeriodicitySelect = ({ value, ...props }) => (
  <DomainSelect
    label={"Периодичность"}
    reducerKey={"periodicity"}
    initialOptions={[
      { id: "раз в полгода", name: "раз в полгода" },
      { id: "раз в год", name: "раз в год" },
      { id: "раз в 2 года", name: "раз в 2 года" },
      { id: "раз в 3 года", name: "раз в 3 года" },
      { id: "раз в 4 года", name: "раз в 4 года" },
      { id: "раз в 5 лет", name: "раз в 5 лет" },
    ]}
    isNullable
    {...props}
    value={value}
  />
);

export const ContractSelect = ({year, value, ...props}) => <DomainSelect
  label={"Договор"}
  reducerKey={"contract"}
  reducerArrayKey={"contracts"}
  reducerAction={getContracts}
  reducerQuery={{ filter: {
    actionAt: { operand1: new Date(year, 1, 1), operand2: new Date(year, 12, 31), operator: "between" },
    typeId: { operand1: CONTRACT_TYPE_ID_GOVERNMENT_REQUESTS, operator: "equals" }
  } }}
  {...props}
  value={value}
/>

export const OrganizationSelect = ({value, ...props}) => <DomainSelect
  label={"Организация"}
  reducerKey={"organization"}
  initialOptions={mapOrganizationValues()}
  {...props}
  value={value}
/>

export const FilialSelect = ({filialId, filialIds, value, organizationId, 
  enableKsek,
  filterOptions: customFilterOptions, ...props}) => <DomainSelect
  label={"Филиал"}
  reducerKey={"filial"}
  reducerArrayKey={"filials"}
  reducerAction={getFilials}
  filterOptions={(opt) => {
    let result = true;

    if (opt.id == null) {
      return true;
    }

    // Всегда включаем текущий выбранный филиал, даже если он не проходит фильтры
    if (value && opt.id == value) {
      return true;
    }

    // Исключаем записи, начинающиеся с "РГУ"
    if (opt.name && opt.name.startsWith('РГУ') && !enableKsek) {
      return false;
    }

    if (organizationId) {
      result = result && opt.organizationId == organizationId;
    }

    if (filialId) {
      result = result && [filialId, value].includes(opt.id);
    }

    if (filialIds) {
      result = result && [...filialIds, value].includes(opt.id);
    }

    // Применяем пользовательский фильтр, если он передан
    if (customFilterOptions) {
      result = result && customFilterOptions(opt);
    }

    return result;
  }}
  {...props}
  value={value}
/>

export const FilialDivisionSelect = ({ filialId, organizationId, ...props }) => (
  <DomainSelect
    label={"Районное отделение"}
    reducerKey={"filialDivision"}
    reducerArrayKey={"filialDivisions"}
    reducerAction={getFilialDivisions}
    filterOptions={(opt) => {
      let result = true;

      if (opt.id == null) {
        return true;
      }

      if (filialId) {
        result = result && Number(opt.filialId) === Number(filialId);
      }

      return result;
    }}
    {...props}
  />
);

/**
 * Справочник «Город/район» для плана: районные отделения и города (filialDivision),
 * в поле сохраняется name (строка districtCity).
 */
export const PlanDistrictCitySelect = ({
  filialId,
  value,
  onChange,
  label = "Город/район",
  ...props
}) => (
  <DomainSelect
    label={label}
    reducerKey={"filialDivision"}
    reducerArrayKey={"filialDivisions"}
    reducerAction={getFilialDivisions}
    optionValueKey="name"
    optionLabelKey="name"
    value={value || ""}
    filterOptions={(opt) => {
      if (opt.id == null) return true;
      if (value && opt.name === value) return true;
      if (!filialId) return true;
      return Number(opt.filialId) === Number(filialId);
    }}
    onChange={(val) => {
      if (typeof onChange === "function") onChange(val || "");
    }}
    {...props}
  />
);

const FILIAL_DIVISION_REQUIRE_FILIAL_SENTINEL = "__FILIAL_DIVISION_REQUIRE_FILIAL__";

export const FilialDivisionSelect2 = ({
  filialId,
  organizationId,
  query: queryProp,
  requireFilialToLoad = true,
  noFilialHint = "Выберите филиал",
  value: valueProp,
  onChange,
  postProcessOptions: userPostProcess,
  ...props
}) => {
  const normalizeFilialDivisionRow = useCallback(
    (row) => ({
      ...row,
      id: row.id ?? row.Id,
      name: row.name ?? row.Name,
      filialId: row.filialId ?? row.FilialId,
    }),
    []
  );

  const filialMissing =
    requireFilialToLoad && (filialId == null || filialId === "");

  const skipFetch = filialMissing;

  const query = useMemo(() => {
    const base = {
      paging: { skip: 0 },
      sort: { name: { operator: "asc" } },
      select: { members: ["Id", "Name", "FilialId"] },
    };
    const filter = {
      ...(queryProp?.filter || {}),
      ...(filialId != null && filialId !== ""
        ? { filialId: { operand1: Number(filialId), operator: "equals" } }
        : {}),
    };
    return {
      ...base,
      ...queryProp,
      filter,
    };
  }, [filialId, queryProp]);

  const mergedPostProcess = useMemo(() => {
    if (!requireFilialToLoad || !noFilialHint) {
      return userPostProcess;
    }
    return (list) => {
      let out = userPostProcess ? userPostProcess(list) : list;
      if (filialMissing) {
        return [
          {
            id: FILIAL_DIVISION_REQUIRE_FILIAL_SENTINEL,
            name: noFilialHint,
            disabled: true,
          },
          ...out,
        ];
      }
      return out;
    };
  }, [
    requireFilialToLoad,
    noFilialHint,
    filialMissing,
    userPostProcess,
  ]);

  const displayValue = filialMissing ? null : valueProp;

  useEffect(() => {
    if (!filialMissing) {
      return;
    }
    if (valueProp == null || valueProp === "") {
      return;
    }
    onChange?.(null, null);
  }, [filialMissing, valueProp, onChange]);

  const handleChange = (val, opt) => {
    if (val === FILIAL_DIVISION_REQUIRE_FILIAL_SENTINEL) {
      return;
    }
    onChange?.(val, opt);
  };

  return (
    <DomainSelect2
      crud={filialDivisionCRUD}
      query={query}
      skipFetch={skipFetch}
      label={"Районное отделение"}
      reducerKey={"filialDivision"}
      normalizeOption={normalizeFilialDivisionRow}
      postProcessOptions={mergedPostProcess}
      value={displayValue}
      onChange={handleChange}
      {...props}
    />
  );
};

export const ResearchObjectSelect = ({...props}) => <DomainSelect
    label={"Объект исследования"}
    reducerKey={"researchObject"}
    reducerArrayKey={"researchObjects"}
    reducerAction={getResearchObjects}
    {...props}
/>

export const ServiceSelect = ({selectedServices,...props}) => <DomainSelect
    label={"Сервис"}
    reducerKey={"service"}
    reducerArrayKey={"services"}
    reducerAction={getServices}
    filterOptions={(opt) => selectedServices.indexOf(opt.id)===-1}
    {...props}
/>

export const PositionSelect = ({...props}) => <DomainSelect
    label={"Должность"}
    reducerKey={"position"}
    reducerArrayKey={"positions"}
    reducerAction={getPositions}
    {...props}
/>


export const RoleSelect = ({selectedRoles,...props}) => <DomainSelect
    label={"Роль"}
    reducerKey={"role"}
    reducerArrayKey={"roles"}
    reducerAction={getRoles}
    filterOptions={(opt) => selectedRoles.indexOf(opt.id)===-1}
    getOptionLabel={(opt) => {
      if (!opt) return "";
      const mapped = mapRole(opt.code);
      return mapped !== "Не определено" ? mapped : (opt.name || opt.code || "");
    }}
    {...props}
/>

export const DiagnosisSelect = ({...props}) => <DomainSelect
  label={"Диагноз"}
  reducerKey={"disease"}
  reducerArrayKey={"diseases"}
  reducerAction={getDiseases}
  {...props}
/>

export const UnitOfMeasure = ({...props}) => <DomainSelect
  label={"Ед. измерения"}
  reducerKey={"unitOfMeasure"}
  reducerArrayKey={"unitOfMeasures"}
  reducerAction={getUnitOfMeasures}
  {...props}
/>


export const ServiceGroupSelect = ({...props}) => <DomainSelect
  label={"Группа"}
  reducerKey={"serviceGroup"}
  reducerArrayKey={"serviceGroups"}
  reducerAction={getServiceGroups}
  {...props}
/>


export const ServiceKindSelect = ({...props}) => <DomainSelect
  label={"Метод"}
  reducerKey={"serviceKind"}
  reducerArrayKey={"serviceKinds"}
  reducerAction={getServiceKinds}
  {...props}
/>

export const ServiceSubGroupSelect = ({...props}) => <DomainSelect
  label={"Подгруппа"}
  reducerKey={"serviceSubGroup"}
  reducerArrayKey={"serviceSubGroups"}
  reducerAction={getServiceSubGroups}
  {...props}
/>

export const ServiceCategorySelect = ({...props}) => <DomainSelect
  label={"Категория"}
  reducerKey={"serviceCategory"}
  reducerArrayKey={"serviceCategories"}
  reducerAction={getServiceCategories}
  {...props}
/>

export const DepartmentSelect = ({departmentId, value, hideParasitology, ...props}) => {
  const roles = localStorage.getItem("roles");
  const isSuperAdmin = roles && JSON.parse(roles).includes('SuperAdministrator');
  
  return <DomainSelect
    label={"Лаборатория"}
    reducerKey={"department"}
    reducerArrayKey={"departments"}
    reducerAction={getDepartments}
    filterOptions={(opt) => {
      // Скрываем "Отделение паразитологии" для всех, кроме SuperAdministrator (только если передан флаг hideParasitology)
      if (hideParasitology && !isSuperAdmin && opt.name === 'Отделение паразитологии') {
        return false;
      }
      return !departmentId || [departmentId, value].includes(opt.id);
    }}
    {...props}
    value={value}
  />
}

export const ProtocolFormSelect = ({...props}) => <DomainSelect
    label={"Форма протокола"}
    reducerKey={"protocolForm"}
    reducerArrayKey={"protocolForms"}
    optionLabelKey={"number"}
    reducerAction={getProtocolForms}
    {...props}
/>

export const ResultFormSelect = ({...props}) => <DomainSelect
    label={"Форма результата"}
    reducerKey={"resultForm"}
    reducerArrayKey={"resultForms"}
    optionLabelKey={"number"}
    reducerAction={getResultForms}
    {...props}
/>

export const BrigadeSelect = ({...props}) => <DomainSelect
    label={"Тип бригады"}
    reducerKey={"brigadeType"}
    reducerArrayKey={"brigadeTypes"}
    reducerAction={getBrigadeTypes}
    {...props}
/>

export const ProbTypeSelect = ({...props}) => <DomainSelect
    label={"Тип пробы"}
    reducerKey={"probeType"}
    reducerArrayKey={"probeTypes"}
    optionLabelKey={"name"}
    reducerAction={getProbeTypes}
    {...props}
/>

export const ActFormSelect = ({...props}) => <DomainSelect
    label={"Форма акта"}
    reducerKey={"actForm"}
    reducerArrayKey={"actForms"}
    optionLabelKey={"name"}
    reducerAction={getActForms}
    {...props}
/>

export const ResultTypeSelect = ({...props}) => <DomainSelect
    label={"Тип журнала"}
    reducerKey={"resultType"}
    reducerArrayKey={"resultTypes"}
    optionLabelKey={"name"}
    reducerAction={getResultsType}
    {...props}
/>

export const DivisionSelect = ({departmentId, ...props}) => <DomainSelect
  label={"Отдел лаборатории"}
  reducerKey={"division"}
  reducerArrayKey={"divisions"}
  reducerAction={getDivisions}
  filterOptions={(opt) => opt.id !== 5 && (!departmentId || (Number(opt.departmentId) === Number(departmentId)))}
  filterDivisionOptions={(opt) => !departmentId || (opt.departmentId === departmentId)}
  {...props}
/>

export const EmployeesSelect = ({...props}) => <DomainSelect
  label={"Сотрудник"}
  reducerKey={"employee"}
  reducerArrayKey={"employees"}
  reducerAction={getEmployees}
  optionLabelKey={"fullName"}
  {...props}
/>

export const ObjectSectionSelect = ({filter, ...props}) => {
  const defaultFilter = (opt) => {
    if (opt?.isDeleted) return false;
    const name = (opt?.name || '').trim().toLowerCase();
    if (name === 'test') return false;
    return true;
  };
  
  // Функция для удаления дубликатов по имени
  // Предпочитаем записи, которые не помечены как удаленные, и среди них выбираем с меньшим ID
  const removeDuplicates = React.useCallback((options) => {
    if (!options || !Array.isArray(options)) return options;
    
    const normalized = (name) => (name || '').trim().toLowerCase();
    const seen = new Map();
    
    // Сначала собираем все записи по именам
    const groupedByName = new Map();
    options.forEach(opt => {
      if (!opt || !defaultFilter(opt)) return;
      
      const name = normalized(opt.name);
      if (!name) return; // Пропускаем записи без имени
      
      if (!groupedByName.has(name)) {
        groupedByName.set(name, []);
      }
      groupedByName.get(name).push(opt);
    });
    
    // Для каждого имени выбираем лучшую запись
    const result = [];
    groupedByName.forEach((opts, name) => {
      // Сортируем: сначала не удаленные, потом по ID
      opts.sort((a, b) => {
        const aDeleted = a.isDeleted ? 1 : 0;
        const bDeleted = b.isDeleted ? 1 : 0;
        if (aDeleted !== bDeleted) return aDeleted - bDeleted; // Не удаленные первыми
        if (a.id && b.id) return a.id - b.id; // Потом по ID
        return 0;
      });
      
      // Берем первую (лучшую) запись
      result.push(opts[0]);
    });
    
    // Добавляем записи без имени
    options.forEach(opt => {
      if (!opt || !defaultFilter(opt)) return;
      const name = normalized(opt.name);
      if (!name) result.push(opt);
    });
    
    return result;
  }, []);
  
  return <DomainSelect
    label={"Раздел объекта"}
    reducerKey={"anObjectSection"}
    reducerArrayKey={"anObjectSections"}
    reducerAction={getAnObjectSections}
    filterOptions={filter || defaultFilter}
    postProcessOptions={removeDuplicates}
    {...props}
  />
};

export const ObjectSubSectionSelect = ({sectionId, parentId, value, onlyRoots, ...props}) => <DomainSelect
  label={"Подраздел объекта"}
  reducerKey={"anObjectSubSection"}
  reducerArrayKey={"anObjectSubSections"}
  reducerAction={getAnObjectSubSections}
  filterOptions={(opt) => {
    if (opt.id == null) {
      return true;
    }
    if (opt.id === value) {
      return true;
    }
    const hasParent = opt.parentId != null && opt.parentId !== "";
    // L3: дети выбранного L2
    if (parentId != null && parentId !== "") {
      return Number(opt.parentId) === Number(parentId);
    }
    // L2: только корни (без Parent), опционально по разделу
    if (onlyRoots !== false && hasParent) {
      return false;
    }
    if (!sectionId) {
      return onlyRoots === false;
    }
    return Number(opt.sectionId) === Number(sectionId);
  }}
  {...props}
  value={value}
/>

export const SamplingPurposeSelect = ({...props}) => <DomainSelect
  label={"6. Цель отбора образца / обработки для дез"}
  reducerKey={"samplingPurpose"}
  reducerArrayKey={"samplingPurposes"}
  reducerAction={getSamplingPurposes}
  {...props}
/>
export const AdditionalInfoSelect = ({...props}) => <DomainSelect
  label={"Цель отбора (дополнительное поле, заполняется при необходимости)"}
  reducerKey={"referralAdditionalInfo"}
  reducerArrayKey={"referralAdditionalInfos"}
  reducerAction={getReferralAdditionalInfos}
  {...props}
/>
export const InfectionKindSelect = ({...props}) => <DomainSelect
  label={"Заболеваемость"}
  reducerKey={"infectionKind"}
  reducerArrayKey={"infectionKinds"}
  reducerAction={getInfectionKinds}
  {...props}
/>

export const MedicalOrderSelect = ({...props}) => <DomainSelect
  label={"Список приказов для ДДД"}
  reducerKey={"medicalOrder"}
  reducerArrayKey={"medicalOrders"}
  reducerAction={getMedicalOrders}
  getOptionLabel={(opt) => `${opt.code} - ${opt.name} - ${opt.description}`}
  {...props}
/>

export const TechnicalRegulationsOfCustomsUnionsSelect = ({...props}) => <DomainSelect
  label={"ТР/ТС"}
  reducerKey={"technicalRegulationsOfCustomsUnion"}
  reducerArrayKey={"technicalRegulationsOfCustomsUnions"}
  reducerAction={getTechnicalRegulationsOfCustomsUnions}
  getOptionLabel={(opt) => `${opt.code} - ${opt.name} - ${opt.description}`}
  {...props}
/>

export const PurposeOfSelectionsSelect = ({...props}) => <DomainSelect
  label={"Цель отбора"}
  reducerKey={"purposeOfSelection"}
  reducerArrayKey={"purposeOfSelections"}
  reducerAction={getPurposeOfSelections}
  {...props}
/>

/** Справочник факторов (для цели «Санитарно-эпидемиологический мониторинг»). */
export const FactorSelect = ({ ...props }) => (
  <DomainSelect2
    label={"Фактор"}
    crud={factorCRUD}
    query={{
      paging: { skip: 0, take: 500 },
      sort: { name: { operator: "asc" } },
    }}
    searchable
    {...props}
  />
);

/**
 * Справочник объектов комитета (иерархия по factorId).
 * Показывается при факторе «Водные ресурсы».
 */
export const CommitteeObjectSelect = ({ factorId, ...props }) => (
  <DomainSelect2
    label={"Объект"}
    crud={committeeObjectCRUD}
    skipFetch={factorId == null || factorId === ""}
    query={{
      paging: { skip: 0, take: 500 },
      sort: { name: { operator: "asc" } },
      filter:
        factorId != null && factorId !== ""
          ? {
              factorId: {
                operand1: factorId,
                operator: "equals",
              },
            }
          : undefined,
    }}
    searchable
    {...props}
  />
);

/** Как в отчёте «Планирование и исполнение…»: те же исключения и подписи к опциям. */
export const PurposeOfSelectionsSelectFiltered = ({ ...props }) => (
  <DomainSelect
    label={"Цель отбора"}
    reducerKey={"purposeOfSelection"}
    reducerArrayKey={"purposeOfSelections"}
    reducerAction={getPurposeOfSelections}
    optionLabelKey="name"
    filter={(opt) => {
      const normalized = normalizePurposeName(opt?.name);
      return !PURPOSE_OF_SELECTION_EXCLUDE.has(normalized);
    }}
    getOptionLabel={(opt) => {
      const name = opt?.name || "";
      if (
        name.toLowerCase().includes("по заявлению физических") ||
        name.toLowerCase().includes("по заявлению юридических")
      ) {
        return `${name} (для платных услуг)`;
      }
      return name;
    }}
    {...props}
  />
);

// Выдаёт 9 мб данных, пока лучше не использовать, надо править бек
export const LegalPersonSelect = ({...props}) => <DomainSelect
  label={"Организационно-правовая форма"}
  reducerKey={"legalPerson"}
  reducerArrayKey={"legalPersons"}
  reducerAction={getLegalPersons}
  {...props}
/>

export const GovernmentStandardsSelect = ({...props}) => <DomainSelect
  label={"9. НД на метод отбора (тем, кто пробы не отбирает заполнять не нужно)"}
  reducerKey={"governmentStandard"}
  reducerArrayKey={"governmentStandards"}
  reducerAction={getGovernmentStandards}
  {...props}
/>
export const TransportationConditionSelect = ({...props}) => <DomainSelect
  label={"10. Условия транспортировки (тем, кто пробы не отбирает заполнять не нужно)"}
  reducerKey={"transportationCondition"}
  reducerArrayKey={"transportationConditions"}
  reducerAction={getTransportationConditions}
  {...props}
/>

export const StorageConditionSelect = ({...props}) => <DomainSelect
  label={"11. Условия хранения (тем, кто пробы не отбирает заполнять не нужно)"}
  reducerKey={"storageCondition"}
  reducerArrayKey={"storageConditions"}
  reducerAction={getStorageConditions}
  {...props}
/>

export const SamplePreservationMethodSelect = ({...props}) => <DomainSelect
  label={"12. Методы консервации образца"}
  reducerKey={"samplePreservationMethod"}
  reducerArrayKey={"samplePreservationMethods"}
  reducerAction={getSamplePreservationMethods}
  {...props}
/>

export const ReferralAdditionalInfosSelect = ({...props}) => <DomainSelect
  label={"13. Дополнительные сведения"}
  reducerKey={"referralAdditionalInfo"}
  reducerArrayKey={"referralAdditionalInfos"}
  reducerAction={getReferralAdditionalInfos}
  {...props}
/>
export const OrderTypeSelect = ({...props}) => <DomainSelect
  label={"15. Тип заказа"}
  reducerKey={"referralOrderType"}
  reducerArrayKey={"referralOrderTypes"}
  reducerAction={getReferralOrderTypes}
  {...props}
/>
export const GeoObjectSelect = ({...props}) => <DomainSelect
  label={"Адрес"}
  reducerKey={"geoObject"}
  reducerArrayKey={"geoObjects"}
  reducerAction={getGeoObjects}
  {...props}
/>

export const GenderSelect = ({...props}) => <DomainSelect
  label={"Пол"}
  reducerKey={"gender"}
  reducerArrayKey={"genders"}
  reducerAction={getGenders}
  {...props}
/>

export const TrainingProgramSelectComponent = ({...props}) => <TrainingProgramSelect
  label={"Программа обучения"}
  {...props}
/>

export const TrainingTargetGroupSelectComponent = ({programId, ...props}) => <TrainingTargetGroupSelect
  label={"Целевая группа обучения"}
  programId={programId}
  {...props}
/>
// generate
// todo
// export const ActInfoSelect = ({...props}) => <DomainSelect
//   label={"14. №, дата акта от Департамента"}
//   reducerKey={"referralAdditionalInfo"}
//   reducerArrayKey={"referralAdditionalInfos"}
//   reducerAction={getReferralAdditionalInfos}
//   {...props}
// />
